import moment from "moment/moment";

export const emailRegExp =
  /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})|([0-9]{10})+$/;

export const passwordRegExp =
  /^.*(?=.{8,40})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
export const AADHAAR_REGEX = /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/;
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

export function generatePassword(username, dob) {
  const firstFourCapitalized = username.slice(0, 4).toUpperCase();
  const dobComponents = dob.split("-");
  const yearOfBirth = dobComponents[0];
  const monthOfBirth = dobComponents[1];
  const dayOfBirth = dobComponents[2];

  return `${firstFourCapitalized}${yearOfBirth}${monthOfBirth}${dayOfBirth}`;
}

export const generateYear = (startYear) => {
  const years = [];
  // const startYear = 2020;
  const endYear = new Date().getFullYear() + 1;
  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }
  return years.reverse();
};

export const generateYearAll = (startYear) => {
  const years = [];
  // const startYear = 2020;
  const endYear = new Date().getFullYear() + 5;
  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }
  return years;
};

// export function getWeekDates(year, weekNumber) {
//   const weekStart = moment().year(year).week(weekNumber).startOf("week");
//   const weekEnd = moment().year(year).week(weekNumber).endOf("week");
//   const dates = [];
//   let currentDate = weekStart.clone();
//   while (currentDate.isSameOrBefore(weekEnd)) {
//     dates.push(currentDate.format("ddd, MMM Do YYYY"));
//     currentDate.add(1, "day");
//   }
//   return dates;
// }

// export function getCurrentWeekDates() {
//   const currentYear = moment().year();
//   const currentWeekNumber = moment().week();
//   return getWeekDates(currentYear, currentWeekNumber);
// }

// export function getPreviousWeekDates() {
//   const currentYear = moment().year();
//   const currentWeekNumber = moment().week();
//   const previousWeekNumber = currentWeekNumber - 1;
//   return getWeekDates(currentYear, previousWeekNumber);
// }

// export function getNextWeekDates() {
//   const currentYear = moment().year();
//   const currentWeekNumber = moment().week();
//   const nextWeekNumber = currentWeekNumber + 1;
//   return getWeekDates(currentYear, nextWeekNumber);
// }

export function getWeekDates(startDate) {
  const dates = [];
  let currentDate = moment(startDate).startOf("isoWeek"); // Start of the ISO week (Monday)

  for (let i = 0; i < 7; i++) {
    dates.push(currentDate.format("ddd, MMM Do YYYY"));
    currentDate.add(1, "day");
  }
  return dates;
}

export function getCurrentWeekDates() {
  const currentMonday = moment().startOf("isoWeek"); // Start of the ISO week (Monday)
  return getWeekDates(currentMonday);
}

export function getPreviousWeekDates() {
  const currentMonday = moment().startOf("isoWeek"); // Start of the ISO week (Monday)
  const previousMonday = currentMonday.subtract(7, "days");
  return getWeekDates(previousMonday);
}

export function getNextWeekDates() {
  const currentMonday = moment().startOf("isoWeek"); // Start of the ISO week (Monday)
  const nextMonday = currentMonday.add(7, "days");
  return getWeekDates(nextMonday);
}

// // Example usage:
// console.log("Current Week Dates:", getCurrentWeekDates());

// // To get the previous week's dates
// console.log("Previous Week Dates:", getPreviousWeekDates());

// // To get the next week's dates
// console.log("Next Week Dates:", getNextWeekDates());

export function getGreeting() {
  const currentTime = new Date().getHours();
  if (currentTime >= 5 && currentTime < 12) {
    return "Good Morning";
  } else if (currentTime >= 12 && currentTime < 18) {
    return "Good Afternoon";
  } else {
    return "Good Evening";
  }
}

// Function to toggle the "show-menu" class on the element with the "wrapper" class
export function toggleMenu() {
  var wrapper = document.querySelector(".wrapper");
  var isMenuShown = wrapper.classList.contains("show-menu");
  if (isMenuShown) {
    wrapper.classList.remove("show-menu");
  } else {
    wrapper.classList.add("show-menu");
  }
}

export function isCardNumberValid(cardType, cardNumber) {
  if (cardType === "AADHAAR") {
    return AADHAAR_REGEX.test(cardNumber);
  } else if (cardType === "PAN") {
    return PAN_REGEX.test(cardNumber);
  } else {
    throw new Error(`Invalid card type: ${cardType}`);
  }
}

export function truncateString(str) {
  if (str.length > 20) {
    return str.substring(0, 20) + "...";
  }
  return str;
}

export function getCurrentYear() {
  const currentDate = new Date();
  return currentDate.getFullYear();
}

export function formatLeaveType(leaveType) {
  if (leaveType === "PrivilegeLeave" || leaveType === "PL") {
    return leaveType.replace(leaveType, "Privilege Leave");
  }
  if (leaveType === "UnPaidLeave") {
    return leaveType.replace(leaveType, "Un-Paid Leave");
  }
  if (leaveType === "HalfDayLeave" || leaveType === "halfDayLeave" || leaveType === "HALF_DAY") {
    return leaveType.replace(leaveType, "Half Day Leave");
  }
  if (leaveType === "halfYearlyLeave" || leaveType === "HalfYearly") {
    return leaveType.replace(leaveType, "Half Yearly Leave");
  }
  if (leaveType === "ShortLeave") {
    return leaveType.replace(leaveType, "Short Leave");
  }
  if (leaveType === "ONOFFICIALDUTY") {
    return leaveType.replace(leaveType, "On Official Duty");
  }
  if (leaveType === "privilegeLeave") {
    return leaveType.replace(leaveType, "Privilege Leave");
  }
  if (leaveType === "paternityLeave") {
    return leaveType.replace(leaveType, "Paternity Leave");
  }
  if (
    leaveType === "workFromHomeLeave" ||
    leaveType === "WorkFromHome" ||
    leaveType === "WFH"
  ) {
    return leaveType.replace(leaveType, "Work From Home ");
  }
  if (leaveType === "shortLeave") {
    return leaveType.replace(leaveType, "Short Leave");
  }
  if (leaveType === "workFromHomeLeaveForQuarter") {
    return leaveType.replace(leaveType, "Work From Home (current Quarter)");
  }
  if (leaveType === "Week-off") {
    return leaveType.replace(leaveType, "Weekend Off");
  }
  if (leaveType === "PERIODIC") {
    return leaveType.replace(leaveType, "Periodic Leave");
  }
  if (leaveType === "CL" || leaveType === "CasualLeave") {
    return leaveType.replace(leaveType, "Casual Leave");
  }

  return leaveType;
}

export const capitalize = (str) => {
  if (!str) return "";
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatTimestamp = (timestamp) => {
  if (!timestamp) return null;

  const date = new Date(timestamp);

  return date.toLocaleDateString("en-UK");
};

export const formatDate = (dateStr) => {
  return moment.utc(dateStr).format("MMMM D, YYYY");
};

export const truncateText = (text, limit) => {
  if (text.length > limit) {
    return text.substring(0, limit) + "...";
  }
  return text;
};

export function formatToDateOnly(dateObj) {
  if (!dateObj) return "";

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatForDisplay(dateStr) {
  return moment.utc(dateStr, "YYYY-MM-DD").format("MMMM D, YYYY");
}

export function displayFormatDate(dateString, shortMonth = false) {
  if (!dateString) return "-";
  let year, month, day;

  if (dateString.includes("-")) {
    const parts = dateString.split("-");
    if (parts.length === 3) {
      if (parts[0].length === 4) {
        [year, month, day] = parts;
      } else if (parts[2].length === 4) {
        if (Number(parts[0]) > 12) {
          [day, month, year] = parts;
        } else {
          [month, day, year] = parts;
        }
      } else {
        return dateString;
      }
    } else {
      return dateString;
    }
  } else {
    return dateString;
  }

  if (!month || !day || !year) {
    return "-";
  }

  const monthNamesFull = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthNamesShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthIndex = parseInt(month, 10) - 1;
  if (monthIndex < 0 || monthIndex > 11) {
    console.error("Invalid month index:", monthIndex);
    return dateString;
  }

  const dayNumber = parseInt(day, 10);
  const dayPadded = String(dayNumber).padStart(2, "0");

  const monthName = shortMonth
    ? monthNamesShort[monthIndex]
    : monthNamesFull[monthIndex];
  return `${monthName} ${dayPadded}, ${year}`;
}

export const generateMonths = () => {
  return Array.from({ length: 12 }, (_, i) => {
    const date = new Date(0, i);
    return {
      value: String(i + 1).padStart(2, "0"),
      label: date.toLocaleString("default", { month: "long" }),
    };
  });
};

export const getYearsUpToCurrent = (startYear) => {
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  return years.reverse(); // latest year first
};

export const formatScreenTime = (minutes) => {
  if (!minutes || minutes === 0) return "0";

  if (minutes < 60) return `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  return `${hours}h ${mins}m`;
};

export function formatDateTime(dateString) {
  if (!dateString) return "";

  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-IN", { month: "long" });
  const year = date.getFullYear();

  const time = date
    .toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .toUpperCase();

  return `${day} ${month} ${year}, ${time}`;
}

export function getMaxDate() {
  const today = new Date();
  today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
  return today.toISOString().split("T")[0];
}


export function forFormatDDMMYYYY(dateString, shortMonth = false) {
  if (!dateString) return "-";

  const parts = dateString.split("-");
  if (parts.length !== 3) return dateString;

  const [day, month, year] = parts;

  // basic validation
  if (year.length !== 4) return dateString;

  const monthIndex = parseInt(month, 10) - 1;
  const dayNumber = parseInt(day, 10);

  if (
    isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11 ||
    isNaN(dayNumber) || dayNumber < 1 || dayNumber > 31
  ) {
    return dateString;
  }

  const monthNamesFull = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const monthNamesShort = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const monthName = shortMonth
    ? monthNamesShort[monthIndex]
    : monthNamesFull[monthIndex];

  return `${monthName} ${String(dayNumber).padStart(2, "0")}, ${year}`;
}

/** First non-empty field value from a record (e.g. alternate API key names). */
export function getFirstDefinedField(record, ...fieldNames) {
  if (!record) return "";
  for (const name of fieldNames) {
    const value = record[name];
    if (value != null && String(value).trim() !== "") {
      return value;
    }
  }
  return "";
}

/**
 * Parses API date strings into calendar parts without timezone shift.
 * Supports ISO timestamps (uses date before "T"), dd-MM-yyyy, and yyyy-MM-dd.
 */
export function parseCalendarDateParts(dateValue) {
  const s = String(dateValue ?? "").trim();
  if (!s) return null;

  if (s.includes("T")) {
    const datePart = s.split("T")[0];
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
    if (!match) return null;
    return { year: match[1], month: match[2], day: match[3] };
  }

  const ddMmYyyy = /^(\d{2})-(\d{2})-(\d{4})$/.exec(s);
  if (ddMmYyyy) {
    return { day: ddMmYyyy[1], month: ddMmYyyy[2], year: ddMmYyyy[3] };
  }

  const yyyyMmDd = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (yyyyMmDd) {
    return { year: yyyyMmDd[1], month: yyyyMmDd[2], day: yyyyMmDd[3] };
  }

  return null;
}

/** Formats a calendar date for display (e.g. "June 10, 2026"). */
export function formatCalendarDateDisplay(dateValue, emptyLabel = "-") {
  const parts = parseCalendarDateParts(dateValue);
  if (!parts) {
    return dateValue != null && String(dateValue).trim() !== ""
      ? String(dateValue)
      : emptyLabel;
  }
  return forFormatDDMMYYYY(`${parts.day}-${parts.month}-${parts.year}`);
}

/** Formats a calendar date for HTML date inputs (yyyy-MM-dd). */
export function formatCalendarDateForInput(dateValue) {
  const parts = parseCalendarDateParts(dateValue);
  if (!parts) return "";
  return `${parts.year}-${parts.month}-${parts.day}`;
}

const INDIA_PHONE_LOCATIONS = new Set([
  "CCI_INDIA",
  "IVYCLINIC",
  "IRED_INDIA",
  "SQE",
  "SQELABS",
]);

/** Formats an employee phone number using the country implied by location. */
export function getEmployeePhone(phoneNumber, location) {
  const phone = String(phoneNumber ?? "").trim();
  const normalizedLocation = String(location ?? "").trim().toUpperCase();
  const countryCode = INDIA_PHONE_LOCATIONS.has(normalizedLocation)
    ? "+91"
    : normalizedLocation === "CCI_UK"
      ? "+44"
      : normalizedLocation === "CCI_US"
        ? "+1"
        : "";

  if (!phone || !countryCode) return { href: phone, display: phone };

  const phoneDigits = phone.replace(/\D/g, "");
  const nationalNumber = phone.startsWith("+91")
    ? phoneDigits.slice(2)
    : phone.startsWith("+44")
      ? phoneDigits.slice(2)
      : phone.startsWith("+1")
        ? phoneDigits.slice(1)
        : phoneDigits;

  if (countryCode === "+91") {
    return {
      href: `${countryCode}${nationalNumber}`,
      display: `${countryCode} ${nationalNumber.replace(/(\d{5})(\d{5})/, "$1-$2")}`,
    };
  }

  if (countryCode === "+1") {
    return {
      href: `${countryCode}${nationalNumber}`,
      display: `${countryCode} (${nationalNumber.slice(0, 3)}) ${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6, 10)}`,
    };
  }

  return {
    href: `${countryCode}${nationalNumber}`,
    display: `${countryCode} ${nationalNumber}`,
  };
}
